import Vue from 'vue'
export default {
  data () {
    return {}
  },
  watch: {},
  created () {
    console.warn('App setGlobalMethods.mixin.js')
    Vue.prototype.$_permissions_click = this._permissions_click
    Vue.prototype.$_linkBack = this._linkBack
  },
  methods: {
    _linkBack () {
      console.log('_linkBack', this.$router, window.history)
      const length = window.history?.length
      if (length <= 2) {
        // 正常来讲都是 1 ，2的话返回基本也是 home
        this.$router.replace('/')
      } else {
        this.$router.go(-1)
      }
    },

    _permissions_click (fn = () => {}, type = 'login') {
      // if (type == 'login') {//pat 也需要登录
      if (!this.vuex_isp_app_token) {
        this.$myDialog({
          title: '请先登录',
          showCancelButton: true,
          confirmButtonText: '前往登录'
        })
          .then(() => {
            // on confirm

            // this.$myUniSDK?.loginIn();
          })
          .catch(() => {
            // on cancel
          })
        return
      }
      // } else
      if (type == 'pat') {
        // 就诊人，要先登录
        if (!this.vuex_isp_currentPatient) {
          this.$myDialog({
            title: '请先绑定并选择就诊人',
            showCancelButton: true,
            confirmButtonText: '前往绑定'
          })
            .then(() => {
              // on confirm

              // this.$myUniSDK?.changePatient();
            })
            .catch(() => {
              // on cancel
            })
          return
        }
      }
      console.log('fn')
      fn()
    }
  }
}
